"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends11 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _models = require("../models");
var _utils = require("../utils");
var _consts = require("../utils/consts");
var _excluded = ["includePermission", "includeAll"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The folder service, is used to fetch folder related data.
 */
var Folder = /*#__PURE__*/function (_Base) {
  /**
   * Create the folder service instance.
   *
   * @param sdk - the SDK instance
   */
  function Folder(sdk) {
    var _this;
    (0, _classCallCheck2["default"])(this, Folder);
    _this = _callSuper(this, Folder, [sdk]);
    _this.folderCancelTokenMap = new Map();
    _this.folderPermissionCancelTokenMap = new Map();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Folder, _Base);
  return (0, _createClass2["default"])(Folder, [{
    key: "getFolders",
    value: (
    /**
     * Get top folders
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders/get
     *
     * @param projectId - , is the project id
     * @param options - the query parameters. With the configurable options
     *                          \{ include_public: true, include_permission: true \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns array of folders.
     */
    function () {
      var _getFolders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, options, config) {
        var _this2 = this;
        var conf, query, url, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Setup cancel token
              conf = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.listFolderCancelToken;
                },
                setter: function setter(token) {
                  return _this2.listFolderCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.listFolderCancelToken = undefined;
                }
              }), config);
              query = _qs["default"].stringify(options, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/folders").concat(query);
              _context.next = 5;
              return this.HttpService.dmV1.get(url, conf);
            case 5:
              response = _context.sent;
              if (!(!response.data || !response.data.folders)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", []);
            case 8:
              return _context.abrupt("return", response.data.folders.map(_models.FolderItem.parseV1));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFolders(_x, _x2, _x3) {
        return _getFolders.apply(this, arguments);
      }
      return getFolders;
    }()
    /**
     * Get user top folders
     * https://platform.stoplight.autodesk.com/docs/docs-cp/037b592310207-shared-list-top-folders-in-project
     *
     * @param projectId - The project id
     * @param params - The request params, shape of \{
     *          folderType: 'plan' | 'normal',
     *          includePermission: boolean,
     *          limit: number,
     *          offset: number,
     *          permission: 'VIEW' | 'DOWNLOAD' | 'COLLABORATE' | 'PUBLISH' | 'PUBLISH_MARKUP' | 'EDIT' | 'CONTROL'
     *        \}
     * @param config - Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "getTopFolders",
    value: (function () {
      var _getTopFolders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, params, config) {
        var query, url, response, _response$data, results, pagination;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/top-folder").concat(query);
              _context2.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              response = _context2.sent;
              _response$data = response.data, results = _response$data.results, pagination = _response$data.pagination;
              return _context2.abrupt("return", {
                folders: results.map(_models.FolderItem.parseV3),
                pagination: pagination
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getTopFolders(_x4, _x5, _x6) {
        return _getTopFolders.apply(this, arguments);
      }
      return getTopFolders;
    }()
    /**
     * Get folders by ids or urns, folder id is private which does not expose to FE.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/f3678c862f240-shared-list-folders-by-ids-or-urns
     *
     * @param projectId - , is the project id
     * @param params - the request params, shape of \{ includePermission: boolean \}
     * @param payload - the request payload, shape of \{ ids: ['id-1'], urns: ['urn-1'] \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns object of folders, shape of \{ errors: [], results: [] \}
     */
    )
  }, {
    key: "getFoldersByUrns",
    value: (function () {
      var _getFoldersByUrns = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId) {
        var _this3 = this;
        var params,
          payload,
          config,
          conf,
          query,
          url,
          res,
          _res$data,
          errors,
          results,
          _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              payload = _args3.length > 2 ? _args3[2] : undefined;
              config = _args3.length > 3 ? _args3[3] : undefined;
              conf = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.getFoldersByUrnsCancelToken;
                },
                setter: function setter(token) {
                  return _this3.getFoldersByUrnsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.getFoldersByUrnsCancelToken = undefined;
                }
              }), config);
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/folders:batch-get").concat(query);
              _context3.next = 8;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 8:
              res = _context3.sent;
              _res$data = res.data, errors = _res$data.errors, results = _res$data.results;
              return _context3.abrupt("return", {
                errors: errors,
                results: results.map(_models.FolderItem.parseV3)
              });
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getFoldersByUrns(_x7) {
        return _getFoldersByUrns.apply(this, arguments);
      }
      return getFoldersByUrns;
    }()
    /**
     * Get a specific folder info
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Burn%7D/get
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param options - is to support pagination parameters
     *                           \{
     *                             limit: 10,
     *                             offset: 0,
     *                             include_permission: true,
     *                             include_deleted: true
     *                           \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns A folder object with sub folders. If the pagination parameter `options`
     *                   is passed, it support page its subfolders.
     */
    )
  }, {
    key: "getFolder",
    value: (function () {
      var _getFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, folderUrn, options, config) {
        var _this4 = this,
          _response$data2;
        var conf, query, url, response, folder;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // Setup cancel token based on folder urn.
              conf = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.folderCancelTokenMap.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this4.folderCancelTokenMap.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this4.folderCancelTokenMap["delete"](folderUrn);
                }
              }), config);
              query = _qs["default"].stringify(options, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/folders/").concat(folderUrn).concat(query);
              _context4.next = 5;
              return this.HttpService.dmV1.get(url, conf);
            case 5:
              response = _context4.sent;
              folder = _models.FolderItem.parseV1((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.attributes);
              folder.folders = (response.data.folders || []).map(_models.FolderItem.parseV1);
              folder.hasNext = !!response.data.has_next_page;
              return _context4.abrupt("return", folder);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getFolder(_x8, _x9, _x10, _x11) {
        return _getFolder.apply(this, arguments);
      }
      return getFolder;
    }()
    /**
     * Get the folder tree data with a given folder urn.
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Burn%7D~1folder_tree/get
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param conf - , Configurable object for overwrite request parameters.
     * @returns array of folders.
     */
    )
  }, {
    key: "getFolderTree",
    value: (function () {
      var _getFolderTree = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, folderUrn, conf) {
        var _this5 = this,
          _response$data3;
        var config, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              config = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this5.deepFolderCancelToken;
                },
                setter: function setter(token) {
                  return _this5.deepFolderCancelToken = token;
                },
                clearer: function clearer() {
                  return _this5.deepFolderCancelToken = undefined;
                }
              }), conf);
              _context5.next = 3;
              return this.HttpService.dmV1.get("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/folder_tree"), config);
            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", (((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.folder_tree) || []).map(_models.FolderItem.parseV1));
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getFolderTree(_x12, _x13, _x14) {
        return _getFolderTree.apply(this, arguments);
      }
      return getFolderTree;
    }()
    /**
     * Get parent folders info.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1folders~1%7Bfolder_urn%7D~1parents/get
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param config - Configurable object to overwrite request parameters, with the shape of
     *                        \{ includePermission: true, includeAll: true, CANCEL_KEYS: \{ getter, setter, clearer \}, .... \}
     * @returns folder object appended with parent folders info
     *                  urn path at`urnPath`
     *                  title path at `path`.
     */
    )
  }, {
    key: "getFolderWithParents",
    value: (function () {
      var _getFolderWithParents = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, folderUrn, config) {
        var _ref, _ref$includePermissio, includePermission, _ref$includeAll, includeAll, rest, response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref = config || {}, _ref$includePermissio = _ref.includePermission, includePermission = _ref$includePermissio === void 0 ? true : _ref$includePermissio, _ref$includeAll = _ref.includeAll, includeAll = _ref$includeAll === void 0 ? true : _ref$includeAll, rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
              _context6.next = 3;
              return this.HttpService.dmV2.get("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/parents?includePermission=").concat(includePermission, "&includeAll=").concat(includeAll), rest);
            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", _models.FolderItem.parseParentsV2(response.data || []));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getFolderWithParents(_x15, _x16, _x17) {
        return _getFolderWithParents.apply(this, arguments);
      }
      return getFolderWithParents;
    }()
    /**
     * Create folder
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Folder%20operation%20APIs.oas2.yml?view=%2Fsingle-apis%2Ffoldercreate
     *
     * @param projectId - , is the project id
     * @param payload - new folder title and parent folder info. With the shape of
     *                        \{ parentFolderUrn: 'The folder urn', name: 'Name of new folder' \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns created folder object
     */
    )
  }, {
    key: "createFolder",
    value: (function () {
      var _createFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/folders"), payload, config);
            case 2:
              response = _context7.sent;
              return _context7.abrupt("return", response.data ? _models.FolderItem.parseV3(response.data) : null);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function createFolder(_x18, _x19, _x20) {
        return _createFolder.apply(this, arguments);
      }
      return createFolder;
    }()
    /**
     * Rename folder
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Folder%20operation%20APIs.oas2.yml?view=%2Fsingle-apis%2Ffolderrename
     *
     * @param projectId - , is the project id
     * @param payload - new folder title info. With the shape of
     *                         \{ name: 'New folder name', urn: 'The folder urn' \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns updated folder object
     */
    )
  }, {
    key: "renameFolder",
    value: (function () {
      var _renameFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/folders:rename"), payload, config);
            case 2:
              response = _context8.sent;
              return _context8.abrupt("return", response.data ? _models.FolderItem.parseV3(response.data) : null);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function renameFolder(_x21, _x22, _x23) {
        return _renameFolder.apply(this, arguments);
      }
      return renameFolder;
    }()
    /**
     * Delete folders
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1be92f6ef4130-shared-batch-delete-folders
     *
     * @param projectId - , the project id
     * @param folderUrns - , array of delete folder urns
     * @param config - , Configurable object for overwrite request parameters.
     * @returns delete result. With the shape of
     *                 \{
     *                   results: [\{ urn: 'urn-1', ... \}], // Array of deleted folders
     *                   errors: [\{
     *                     id: 'folder-urn',
     *                     code: 'error code',
     *                     detail: 'error details'
     *                   \}] // Error array which contains error detail for each failure folder.
     *                 \}
     */
    )
  }, {
    key: "deleteFolders",
    value: (function () {
      var _deleteFolders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(projectId, folderUrns, config) {
        var response, _response$data4, results, errors;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/folders:batch-delete"), {
                folders: folderUrns
              }, config);
            case 2:
              response = _context9.sent;
              _response$data4 = response.data, results = _response$data4.results, errors = _response$data4.errors;
              return _context9.abrupt("return", {
                results: results.map(_models.FolderItem.parseV3),
                errors: errors
              });
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function deleteFolders(_x24, _x25, _x26) {
        return _deleteFolders.apply(this, arguments);
      }
      return deleteFolders;
    }()
    /**
     * Move existing folder
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Folder%20operation%20APIs.oas2.yml?view=%2Fsingle-apis%2Ffoldermove
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param targetFolderUrn - , is the target urn
     * @param config - Configurable object for overwrite request parameters.
     * @returns moved folder object
     */
    )
  }, {
    key: "moveFolder",
    value: (function () {
      var _moveFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(projectId, folderUrn, targetFolderUrn, config) {
        var res;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/folders:move"), {
                folderUrn: folderUrn,
                targetFolderUrn: targetFolderUrn
              }, config);
            case 2:
              res = _context10.sent;
              return _context10.abrupt("return", res.data ? _models.FolderItem.parseV3(res.data) : null);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function moveFolder(_x27, _x28, _x29, _x30) {
        return _moveFolder.apply(this, arguments);
      }
      return moveFolder;
    }()
    /**
     * Get permission info for a specific folder
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Bfolder_urn%7D~1get_permission/get
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param conf - , Configurable object for overwrite request parameters.
     * @returns Permission actions that related to the folder. With the shape of ["VIEW", "COLLABORATE", "DOWNLOAD"]
     */
    )
  }, {
    key: "getFolderPermission",
    value: (function () {
      var _getFolderPermission = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(projectId, folderUrn, conf) {
        var _this6 = this;
        var config, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              config = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, (conf === null || conf === void 0 ? void 0 : conf.cancelByFolder) === true ? {
                getter: function getter() {
                  return _this6.folderPermissionCancelTokenMap.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this6.folderPermissionCancelTokenMap.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this6.folderPermissionCancelTokenMap["delete"](folderUrn);
                }
              } : {
                getter: function getter() {
                  return _this6.folderPermissionCancelToken;
                },
                setter: function setter(token) {
                  return _this6.folderPermissionCancelToken = token;
                },
                clearer: function clearer() {
                  return _this6.folderPermissionCancelToken = undefined;
                }
              }), conf);
              _context11.next = 3;
              return this.HttpService.dmV1.get("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/get_permission"), config);
            case 3:
              response = _context11.sent;
              if (!(!response.data || !response.data.permission_actions)) {
                _context11.next = 6;
                break;
              }
              return _context11.abrupt("return", []);
            case 6:
              return _context11.abrupt("return", response.data.permission_actions);
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getFolderPermission(_x31, _x32, _x33) {
        return _getFolderPermission.apply(this, arguments);
      }
      return getFolderPermission;
    }()
    /**
     * Get permission list (users, roles, companies) related to a specific folder.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Bfolder_id%7D~1permissions/get
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param conf - Configurable object for overwrite request parameters.
     * @returns Permissions that related to the folder. With the shape of  [PermissionItem].
     */
    )
  }, {
    key: "getFolderPermissions",
    value: (function () {
      var _getFolderPermissions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(projectId, folderUrn, conf) {
        var _this7 = this;
        var config, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              config = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this7.folderPermissionsCancelToken;
                },
                setter: function setter(token) {
                  return _this7.folderPermissionsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this7.folderPermissionsCancelToken = undefined;
                }
              }), conf);
              _context12.next = 3;
              return this.HttpService.dmV2.get("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/permissions"), config);
            case 3:
              response = _context12.sent;
              if (!(!response.data || response.data.length <= 0)) {
                _context12.next = 6;
                break;
              }
              return _context12.abrupt("return", []);
            case 6:
              return _context12.abrupt("return", (0, _uniqBy["default"])(response.data.map(_models.PermissionItem.parseV2), function (_ref2) {
                var id = _ref2.id;
                return id;
              }));
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getFolderPermissions(_x34, _x35, _x36) {
        return _getFolderPermissions.apply(this, arguments);
      }
      return getFolderPermissions;
    }()
    /**
     * Add folder permission
     * https://platform.stoplight.autodesk.com/docs/docs-cp/a8ec4db01ff0f-create-a-project-folder-permissions-batch-create
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param items - is the permission items. With the shape of
     *                      \{
     *                        actions: ["VIEW", "COLLABORATE", "DOWNLOAD"],
     *                        displayName: 'AAA',
     *                        email: 'chevalier20051101\@yopmail.com',
     *                        subjectId: '312bce28-e0e6-4a38-9cdd-577b4ad2b50b',
     *                        subjectType: 'USER'
     *                      \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns added result. With the shape of
     *                 \{
     *                   results: [\{
     *                     actions: ["VIEW", "COLLABORATE", "DOWNLOAD"],
     *                     displayName: 'AAA',
     *                     email: 'chevalier20051101\@yopmail.com',
     *                     subjectId: '312bce28-e0e6-4a38-9cdd-577b4ad2b50b',
     *                     subjectType: 'USER'
     *                   \}],
     *                   errors: [\{
     *                     id: 'folder-urn',
     *                     code: 'error code',
     *                     detail: 'error details'
     *                   \}] // Error array which contains error detail for each failure folder.
     *                 \}
     */
    )
  }, {
    key: "addFolderPermissions",
    value: (function () {
      var _addFolderPermissions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13(projectId, folderUrn, items, config) {
        var response;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.HttpService.dmV2.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/permissions:batch-create"), items.map(_utils.PermissionUtil.transformForV2Permission), config);
            case 2:
              response = _context13.sent;
              return _context13.abrupt("return", response.data);
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function addFolderPermissions(_x37, _x38, _x39, _x40) {
        return _addFolderPermissions.apply(this, arguments);
      }
      return addFolderPermissions;
    }()
    /**
     * Delete folder permission
     * https://platform.stoplight.autodesk.com/docs/docs-cp/c03da6b762e6b-create-a-project-folder-permissions-batch-delete
     *
     * @param projectId - is the project id
     * @param folderUrn - is the folder urn
     * @param query - is the url parameters. With the shape of
     *                        \{ hint: 'remove' / 'reset' \}
     * @param items - is the permission items.  With the shape of
     *                      [\{
     *                        subjectId: "384c3c3e-e5f8-4bb6-8ba4-203c9b805e75",
     *                        subjectType: "USER"
     *                      \}]
     * @param config - Configurable object for overwrite request parameters.
     * @returns Empty result if deleted.
     */
    )
  }, {
    key: "delFolderPermissions",
    value: (function () {
      var _delFolderPermissions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14(projectId, folderUrn, query, items, config) {
        var urlQuery;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              urlQuery = _qs["default"].stringify(query, {
                addQueryPrefix: true
              });
              _context14.next = 3;
              return this.HttpService.dmV2.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/permissions:batch-delete").concat(urlQuery), items.map(_utils.PermissionUtil.transformForV2Permission), config);
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function delFolderPermissions(_x41, _x42, _x43, _x44, _x45) {
        return _delFolderPermissions.apply(this, arguments);
      }
      return delFolderPermissions;
    }()
    /**
     * Update folder permission
     * https://platform.stoplight.autodesk.com/docs/docs-cp/b8e8bd451d103-create-a-project-folder-permissions-batch-update
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param items - is the permission items. With the shape of
     *                      [\{
     *                        actions: ["VIEW"],
     *                        subjectId: "384c3c3e-e5f8-4bb6-8ba4-203c9b805e75",
     *                        subjectType: "USER"
     *                      \}]
     * @param config - Configurable object for overwrite request parameters.
     * @returns updated result. With the shape of
     *                 \{
     *                   results: [\{
     *                     actions: ["VIEW"],
     *                     subjectId: "384c3c3e-e5f8-4bb6-8ba4-203c9b805e75",
     *                     subjectType: "USER"
     *                   \}],
     *                   errors: [\{
     *                     id: 'folder-urn',
     *                     code: 'error code',
     *                     detail: 'error details'
     *                   \}] // Error array which contains error detail for each failure folder.
     *                 \}
     */
    )
  }, {
    key: "updateFolderPermissions",
    value: (function () {
      var _updateFolderPermissions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15(projectId, folderUrn, items, config) {
        var response;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.HttpService.dmV2.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/permissions:batch-update"), items.map(_utils.PermissionUtil.transformForV2Permission), config);
            case 2:
              response = _context15.sent;
              return _context15.abrupt("return", response.data);
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function updateFolderPermissions(_x46, _x47, _x48, _x49) {
        return _updateFolderPermissions.apply(this, arguments);
      }
      return updateFolderPermissions;
    }()
    /**
     * Query folders by filter.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/branches/master/a10ceab8ef57f-shared-sort-and-filter-sub-folders
     *
     * @param projectId -  is the project id
     * @param folderUrn - , is the folder urn
     * @param options - is to support pagination, sorting and filtering parameters
     *                           \{
     *                             limit: integer
     *                             offset: integer,
     *                             sort: [\{ name: string, acs: boolean \}],
     *                             filter: \{ isDeleted: boolean, updatedBy: string, updatedAt: string or null \}
     *                           \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns filter result. With the shape of
     *                 \{
     *                   folders:[], // Array of folders
     *                   pagination: \{
     *                     limit: integer,
     *                     offset: integer,
     *                     next: string or null,
     *                     totalResults: integer,
     *                     hasNext: boolean
     *                   \}
     *                 \}
     */
    )
  }, {
    key: "getFoldersByFilter",
    value: (function () {
      var _getFoldersByFilter = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16(projectId, folderUrn, options, config) {
        var _this8 = this;
        var conf, url, response, _response$data5, _response$data5$resul, results, _response$data5$pagin, pagination;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              conf = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this8.loadFoldersCancelToken;
                },
                setter: function setter(token) {
                  return _this8.loadFoldersCancelToken = token;
                },
                clearer: function clearer() {
                  return _this8.loadFoldersCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/folders:query");
              _context16.next = 4;
              return this.HttpService.dmV3.post(url, options, conf);
            case 4:
              response = _context16.sent;
              _response$data5 = response.data, _response$data5$resul = _response$data5.results, results = _response$data5$resul === void 0 ? [] : _response$data5$resul, _response$data5$pagin = _response$data5.pagination, pagination = _response$data5$pagin === void 0 ? {} : _response$data5$pagin;
              return _context16.abrupt("return", {
                folders: results.map(_models.FolderItem.parseV3),
                pagination: (0, _extends11["default"])({}, pagination, {
                  hasNext: !!pagination.nextUrl
                })
              });
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getFoldersByFilter(_x50, _x51, _x52, _x53) {
        return _getFoldersByFilter.apply(this, arguments);
      }
      return getFoldersByFilter;
    }()
    /**
     * get deleted folders and documents under a specific folder
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Burn%7D~1get_content_by_properties/post
     *
     * @param projectId - is the project id
     * @param folderUrn - is the folder urn
     * @param options - is to support pagination parameters
     *                           \{
     *                             limit: 200
     *                             offset: 0
     *                           \}
     * @param conf - Configurable object for overwrite request parameters.
     * @returns deleted entity info. With the shape of
     *                 \{
     *                   folders: [], // Array of folders
     *                   documents: [], // Array of documents
     *                   hasNextPage: [] // Whether has more data
     *                 \}
     */
    )
  }, {
    key: "getDeletedEntities",
    value: (function () {
      var _getDeletedEntities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17(projectId, folderUrn, options, conf) {
        var _this9 = this;
        var params, config, response;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              params = {
                options: (0, _extends11["default"])({
                  properties: [{
                    name: 'hidden',
                    value: true,
                    is_system: true,
                    data_type: 'BOOLEAN'
                  }]
                }, options)
              };
              config = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this9.loadDeleteEntitiesCancelToken;
                },
                setter: function setter(token) {
                  return _this9.loadDeleteEntitiesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this9.loadDeleteEntitiesCancelToken = undefined;
                }
              }), conf);
              _context17.next = 4;
              return this.HttpService.dmV1.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/get_content_by_properties"), params, config);
            case 4:
              response = _context17.sent;
              if (!response.data) {
                _context17.next = 7;
                break;
              }
              return _context17.abrupt("return", {
                folders: (response.data.folders || []).map(_models.FolderItem.parseV1),
                documents: (response.data.documents || []).map(_models.EntityItem.parseV1),
                hasNextPage: !!response.data.has_next_page
              });
            case 7:
              return _context17.abrupt("return", null);
            case 8:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getDeletedEntities(_x54, _x55, _x56, _x57) {
        return _getDeletedEntities.apply(this, arguments);
      }
      return getDeletedEntities;
    }()
    /**
     * restore folders
     * https://platform.stoplight.autodesk.com/docs/docs-cp/c7eccbbad1dde-shared-batch-restore-folders
     *
     * @param projectId -  is the project id
     * @param folderUrns - are the folder urns
     * @param config - Configurable object for overwrite request parameters.
     * @returns restore result. With the shape of
     *                 \{
     *                   results: [\{ urn: 'urn-1', ... \}], // Array of restored folders
     *                   errors: [\{
     *                     id: 'folder-urn',
     *                     code: 'error code',
     *                     detail: 'error details'
     *                   \}] // Error array which contains error detail for each failure folder.
     *                 \}
     */
    )
  }, {
    key: "restoreFolders",
    value: (function () {
      var _restoreFolders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18(projectId, folderUrns, config) {
        var response, _response$data6, _response$data6$resul, results, _response$data6$error, errors;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/folders:batch-restore"), {
                folders: folderUrns
              }, config);
            case 2:
              response = _context18.sent;
              _response$data6 = response.data, _response$data6$resul = _response$data6.results, results = _response$data6$resul === void 0 ? [] : _response$data6$resul, _response$data6$error = _response$data6.errors, errors = _response$data6$error === void 0 ? [] : _response$data6$error;
              return _context18.abrupt("return", {
                results: results.map(_models.FolderItem.parseV3),
                errors: errors
              });
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function restoreFolders(_x58, _x59, _x60) {
        return _restoreFolders.apply(this, arguments);
      }
      return restoreFolders;
    }()
    /**
     * subscribe folder
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Folder%20operation%20APIs.oas2.yml?view=%2Fsubscription-apis%2Ffoldersubscriptioncreate
     *
     * @param projectId -  is the project id
     * @param folderUrn - is the folder urn
     * @param isRecursive - subscribe subfolders or not, true/false.
     * @param config - Configurable object for overwrite request parameters.
     * @returns updated folder object
     */
    )
  }, {
    key: "subscribeFolder",
    value: (function () {
      var _subscribeFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19(projectId, folderUrn) {
        var isRecursive,
          config,
          path,
          response,
          _args19 = arguments;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              isRecursive = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : true;
              config = _args19.length > 3 ? _args19[3] : undefined;
              path = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/subscriptions");
              _context19.next = 5;
              return this.HttpService.dmV3.post(path, {
                isRecursive: isRecursive
              }, config);
            case 5:
              response = _context19.sent;
              return _context19.abrupt("return", _models.FolderItem.parseV3(response.data));
            case 7:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function subscribeFolder(_x61, _x62) {
        return _subscribeFolder.apply(this, arguments);
      }
      return subscribeFolder;
    }()
    /**
     * unsubscribe folder
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Folder%20operation%20APIs.oas2.yml?view=%2Fsubscription-apis%2Ffoldersubscriptiondelete
     *
     * @param projectId -  is the project id
     * @param folderUrn - the folder urn
     * @param isRecursive - unsubscribe subfolders or not.
     * @param config - Configurable object for overwrite request parameters.
     * @returns updated folder object
     */
    )
  }, {
    key: "unsubscribeFolder",
    value: (function () {
      var _unsubscribeFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20(projectId, folderUrn) {
        var isRecursive,
          config,
          path,
          response,
          _args20 = arguments;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              isRecursive = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : true;
              config = _args20.length > 3 ? _args20[3] : undefined;
              path = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/subscriptions?isRecursive=").concat(isRecursive);
              _context20.next = 5;
              return this.HttpService.dmV3["delete"](path, config);
            case 5:
              response = _context20.sent;
              return _context20.abrupt("return", _models.FolderItem.parseV3(response.data));
            case 7:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function unsubscribeFolder(_x63, _x64) {
        return _unsubscribeFolder.apply(this, arguments);
      }
      return unsubscribeFolder;
    }()
    /**
     * Get folder naming standards list which is available to any active project user.
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/ACC-Folders.oas2.yml?view=%2Fsingle-apis%2Fgetnsbyurn
     *
     * @param projectId -  the project id
     * @param folderUrn -  the folder urn
     * @param config - Configurable object to overwrite request parameters.
     * @returns a naming standards id list.
     */
    )
  }, {
    key: "getFolderNamingStandards",
    value: (function () {
      var _getFolderNamingStandards = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee21(projectId, folderUrn, config) {
        var response;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/naming-standards"), config);
            case 2:
              response = _context21.sent;
              return _context21.abrupt("return", response.data || []);
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getFolderNamingStandards(_x65, _x66, _x67) {
        return _getFolderNamingStandards.apply(this, arguments);
      }
      return getFolderNamingStandards;
    }()
    /**
     * Apply or remove naming standard to multiple folders.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/5a1968bd734eb-shared-batch-apply-or-remove-naming-standard-of-folders
     *
     * @param projectId -  the project id
     * @param payload - the payload
     * @param config - Configurable object to overwrite request parameters.
     *
     */
    )
  }, {
    key: "enforceNamingStandards",
    value: (function () {
      var _enforceNamingStandards = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee22(projectId, payload, config) {
        var path;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              path = "/projects/".concat(projectId, "/folders/naming-standards:batch-enforce");
              _context22.next = 3;
              return this.HttpService.dmV3.post(path, payload, config);
            case 3:
              return _context22.abrupt("return", _context22.sent);
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function enforceNamingStandards(_x68, _x69, _x70) {
        return _enforceNamingStandards.apply(this, arguments);
      }
      return enforceNamingStandards;
    }()
    /**
     * Check if a folder and its subfolders have files.
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/ACC-Folders.oas2.yml?view=/single-apis/getfolder
     *
     * @param projectId - , is the project id
     * @param folderUrn - , is the folder urn
     * @param params - the request params, shape of \{ includeHasFiles: boolean \}
     * @param conf - Configurable object for overwrite request parameters.
     * @returns a folder object which contains property \{ hasFiles: boolean \}
     */
    )
  }, {
    key: "checkFolderHasFiles",
    value: (function () {
      var _checkFolderHasFiles = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee23(projectId, folderUrn, params, conf) {
        var _this10 = this;
        var config, query, response;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              config = (0, _extends11["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this10.checkHasFilesCancelToken;
                },
                setter: function setter(token) {
                  return _this10.checkHasFilesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this10.checkHasFilesCancelToken = undefined;
                }
              }), conf);
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              _context23.next = 4;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/folders/").concat(folderUrn).concat(query), config);
            case 4:
              response = _context23.sent;
              return _context23.abrupt("return", response.data);
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function checkFolderHasFiles(_x71, _x72, _x73, _x74) {
        return _checkFolderHasFiles.apply(this, arguments);
      }
      return checkFolderHasFiles;
    }()
    /**
     * Get Takeoff publish models hidden folder urn.
     * https://platform.stoplight.autodesk.com/docs/quantification-service/bae626b3a389c-get-a-v-1-project-models-folder
     *
     * @param projectId -  the project uuid
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of \{"folderUrn": "folder-urn"\}
     */
    )
  }, {
    key: "getTakeoffPublishFolder",
    value: (function () {
      var _getTakeoffPublishFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee24(projectId, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              url = "/projects/".concat(projectId, "/models-folder");
              _context24.next = 3;
              return this.HttpService.qtoV1.get(url, config);
            case 3:
              response = _context24.sent;
              return _context24.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function getTakeoffPublishFolder(_x75, _x76) {
        return _getTakeoffPublishFolder.apply(this, arguments);
      }
      return getTakeoffPublishFolder;
    }()
    /**
     * Set project folder viewOption property.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Bfolder_urn%7D/patch
     *
     * @param projectId -  the project uuid
     * @param folderUrn - , folder urn.
     * @param params - whether patch the viewOption to sub-folders, one of [\{"needPropagate": true\}, \{"needPropagate": false\}].
     * @param payload -, one of [\{viewOption: "LMV"\}, \{viewOption: "PDF_NATIVE_VIEWER"\}].
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of \{"name": "folder-name", "parentFolderUrn": "parent-folder-urn", "urn": "folder-urn", "viewOption": "LMV"\}
     */
    )
  }, {
    key: "setFolderPdfViewer",
    value: (function () {
      var _setFolderPdfViewer = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee25(projectId, folderUrn, params, payload, config) {
        var query, url, response;
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/folders/").concat(folderUrn).concat(query);
              _context25.next = 4;
              return this.HttpService.dmV2.patch(url, payload, config);
            case 4:
              response = _context25.sent;
              return _context25.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function setFolderPdfViewer(_x77, _x78, _x79, _x80, _x81) {
        return _setFolderPdfViewer.apply(this, arguments);
      }
      return setFolderPdfViewer;
    }()
    /**
     * Update folder info. e.g. description
     *
     * @param projectId - the project uuid
     * @param folderUrn - folder urn.
     * @param payload - the request payload.
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that return detail folder info.
     */
    )
  }, {
    key: "updateFolder",
    value: (function () {
      var _updateFolder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee26(projectId, folderUrn, payload, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              url = "/projects/".concat(projectId, "/folders/").concat(folderUrn);
              _context26.next = 3;
              return this.HttpService.dmV3.patch(url, payload, config);
            case 3:
              response = _context26.sent;
              return _context26.abrupt("return", _models.FolderItem.parseV3(response.data));
            case 5:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function updateFolder(_x82, _x83, _x84, _x85) {
        return _updateFolder.apply(this, arguments);
      }
      return updateFolder;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Folders';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Folder;